module.exports = "<div v-show=notice.show v-bind:class=state class=Notice><i v-bind:class=icon class=Notice__icon></i><div class=Notice__text>{{ notice.msg[0] | customMessage }}</div><div @click=close(notice) class=Notice__close></div></div>";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-loader.js?raw&engine=jade!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/dialogs/notice.vue
// module id = 415
// module chunks = 0